import clsx from 'clsx';
import { FC } from 'react';
import { getRange } from '../../../../../util';
import { useDatePickerContext } from '../datePicker.context';
import { DatePickerView } from '../types';

interface DatePickerYearViewProps {
  yearOffset: number;
}

export const DatePickerYearView: FC<DatePickerYearViewProps> = ({ yearOffset }) => {
  const { UIYear, setCurrentView, now, chosenDate, setLookedYear } = useDatePickerContext();

  return (
    <div
      className="grid"
      style={{
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      }}
    >
      {getRange(UIYear + yearOffset, UIYear + yearOffset + 20).map((y) => {
        const isChosenYear = chosenDate?.getFullYear() === y;
        return (
          <button
            key={y}
            className={clsx(
              'grid h-8 cursor-pointer content-center rounded-full text-center text-lg text-darkMode-gray-light dark:text-darkMode-gray-light hover:bg-palette-800/20 hover:dark:text-palette-100',
              isChosenYear && '!bg-palette-600',
              now.getFullYear() === y && 'text-palette-600'
            )}
            onClick={() => {
              setLookedYear(y);
              setCurrentView(DatePickerView.MonthPicker);
            }}
          >
            {y}
          </button>
        );
      })}
    </div>
  );
};
